export const articlePairs = [
  { en: 'audio-to-text-for-language-learning', zh: 'yinpin-zhuan-wenzi-xue-yingyu' },
  { en: 'how-to-use-mp3-subtitles-for-listening-practice', zh: 'mp3-zimu-lian-tingli-kouyu' },
  { en: 'how-to-practice-shadowing-with-audio', zh: 'yingyu-genduxunlian-zenme-zuo' },
  { en: 'text-to-speech-for-ielts-speaking', zh: 'yasi-kouyu-yong-tts-lianxi' },
  { en: 'bilingual-subtitles-listening-speaking', zh: 'bilingual-subtitles-listening-speaking' },
  { en: 'intensive-listening-with-ai-transcripts', zh: 'jingting-yingyu-zenme-zuo' },
  { en: 'best-way-to-turn-podcasts-into-speaking-practice', zh: 'boke-lian-kouyu-fangfa' },
  { en: 'why-cant-i-understand-spoken-english', zh: 'yingyu-tingli-tingbudong-zenmeban' },
  { en: 'how-to-review-ielts-listening-mistakes', zh: 'yasi-tingli-cuoti-jingting' },
  { en: 'how-to-practice-english-job-interview-speaking', zh: 'yingyu-mianshi-kouyu-lianxi' },
  { en: 'how-to-review-phrases-from-listening-materials', zh: 'yingyu-duanju-fuxi-fangfa' },
  { en: 'why-speak-english-out-loud-every-day', zh: 'meitian-kai-kou-shuo-yingyu' },
  { en: 'how-to-shadow-bbc-6-minute-english', zh: 'bbc-liu-fenzhong-yingyu-gendu' }
]
